"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _get = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");

var _inherits = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var ElementImpl = require("./Element-impl").implementation;

var MouseEvent = require("../generated/MouseEvent");

var focusing = require("../helpers/focusing.js");

var conversions = require("webidl-conversions");

var isDisabled = require("../helpers/form-controls").isDisabled;

var HTMLElementImpl = /*#__PURE__*/function (_ElementImpl) {
  _inherits(HTMLElementImpl, _ElementImpl);

  function HTMLElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, HTMLElementImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HTMLElementImpl).call(this, args, privateData));
    _this._tabIndex = 0;
    _this._settingCssText = false;
    _this._clickInProgress = false;
    _this._style = new _this._core.CSSStyleDeclaration(function (newCssText) {
      if (!_this._settingCssText) {
        _this._settingCssText = true;

        _this.setAttribute("style", newCssText);

        _this._settingCssText = false;
      }
    });
    return _this;
  } // Add default event behavior (click link to navigate, click button to submit
  // form, etc). We start by wrapping dispatchEvent so we can forward events to
  // the element's default functions (only events that did not incur
  // preventDefault).


  _createClass(HTMLElementImpl, [{
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      if (event.type === "click") {
        callEventBehaviorHook(event, "_preClickActivationSteps", this);
      }

      var outcome = _get(_getPrototypeOf(HTMLElementImpl.prototype), "dispatchEvent", this).call(this, event);

      if (event.type === "click") {
        if (event.defaultPrevented) {
          callEventBehaviorHook(event, "_canceledActivationSteps");
        } else {
          callEventBehaviorHook(event, "_activationBehavior");
        }
      }

      return outcome;
    }
  }, {
    key: "focus",
    value: function focus() {
      if (!focusing.isFocusableAreaElement(this)) {
        return;
      }

      var previous = this._ownerDocument._lastFocusedElement;
      focusing.fireFocusEventWithTargetAdjustment("blur", previous, this);
      this._ownerDocument._lastFocusedElement = this;
      focusing.fireFocusEventWithTargetAdjustment("focus", this, previous);

      if (this._ownerDocument._defaultView._frameElement) {
        this._ownerDocument._defaultView._frameElement.focus();
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      if (this._ownerDocument._lastFocusedElement !== this || !focusing.isFocusableAreaElement(this)) {
        return;
      }

      focusing.fireFocusEventWithTargetAdjustment("blur", this, this._ownerDocument);
      this._ownerDocument._lastFocusedElement = null;
      focusing.fireFocusEventWithTargetAdjustment("focus", this._ownerDocument, this);
    }
  }, {
    key: "click",
    value: function click() {
      // https://html.spec.whatwg.org/multipage/interaction.html#dom-click
      // https://html.spec.whatwg.org/multipage/interaction.html#run-synthetic-click-activation-steps
      // Not completely spec compliant due to e.g. incomplete implementations of disabled for form controls, or no
      // implementation at all of isTrusted.
      if (this._clickInProgress) {
        return;
      }

      this._clickInProgress = true;

      if (isDisabled(this)) {
        return;
      }

      var event = MouseEvent.createImpl(["click", {
        bubbles: true,
        cancelable: true
      }], {}); // Run synthetic click activation steps. According to the spec,
      // this should not be calling dispatchEvent, but it matches browser behavior.
      // See: https://www.w3.org/Bugs/Public/show_bug.cgi?id=12230
      // See also: https://github.com/whatwg/html/issues/805

      this.dispatchEvent(event);
      this._clickInProgress = false;
    }
  }, {
    key: "_attrModified",
    value: function _attrModified(name, value, oldValue) {
      if (name === "style" && value !== oldValue && !this._settingCssText) {
        this._settingCssText = true;
        this._style.cssText = value;
        this._settingCssText = false;
      }

      _get(_getPrototypeOf(HTMLElementImpl.prototype), "_attrModified", this).apply(this, arguments);
    } // TODO this should be [Reflect]able if we added default value support to webidl2js's [Reflect]

  }, {
    key: "style",
    get: function get() {
      return this._style;
    },
    set: function set(value) {
      this._style.cssText = value;
    }
  }, {
    key: "tabIndex",
    get: function get() {
      if (!this.hasAttribute("tabindex")) {
        return focusing.isFocusableAreaElement(this) ? 0 : -1;
      }

      return conversions.long(this.getAttribute("tabindex"));
    },
    set: function set(value) {
      this.setAttribute("tabIndex", String(value));
    }
  }, {
    key: "offsetParent",
    get: function get() {
      return null;
    }
  }, {
    key: "offsetTop",
    get: function get() {
      return 0;
    }
  }, {
    key: "offsetLeft",
    get: function get() {
      return 0;
    }
  }, {
    key: "offsetWidth",
    get: function get() {
      return 0;
    }
  }, {
    key: "offsetHeight",
    get: function get() {
      return 0;
    }
  }]);

  return HTMLElementImpl;
}(ElementImpl);

function callEventBehaviorHook(event, name, targetOverride) {
  if (event) {
    var target = targetOverride || event.target;

    if (target && typeof target[name] === "function") {
      target[name]();
    }
  }
}

module.exports = {
  implementation: HTMLElementImpl
};